module.exports = __webpack_public_path__ + "img/valley-view-mall.22221b15.jpeg";